export const formatOrdinalDate = (dateString) => {
  if (!dateString) return "";
  const day = new Date(dateString).getDate();

  const getOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  return getOrdinal(day); 
};